import React, { useState, useEffect, useCallback } from "react";
import FlyerOptionsCustomizations from "../components/FlyerOptionsCustomizations";
import { useAuth } from "../context/auth-context";
import firebase from "../util/firebase";
import divideRgbBy255 from "../util/divideRgbBy255";
import { useNavigate } from "react-router-dom";
import useGetHeadshot from "../util/useGetHeadshot";

export default function FlyerOptions() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasHeadshot, setHasHeadshot] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const { currentUser } = useAuth();
  const history = useNavigate();

  //see if this is the first time the user is visiting the page

  useEffect(() => {
    const brandData = firebase
      .firestore()
      .collection("branches")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          setBranches((branches) => [...branches, doc.data()]);
        });
      });
    console.log(brandData);
  }, []);
  currentUser.branches = branches;

  useEffect(() => {
    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          currentUser.settings = doc.data();
        } else if (firstRender === true) {
          console.log("No such document!");
        } else {
          setFirstRender(false);
        }
      });
    setLoading(false);
    setFirstRender(false);
  }, [firstRender]);

  const { data, isLoading, error } = useGetHeadshot(
    currentUser.userData?.Website_Headshot__c
  );

  let mloHeadshotActiveUrl = data;

  useEffect(() => {
    currentUser.userData.mloHeadshotFinal = "";
    if (isLoading) {
      return;
    }
    if (loading) {
      return;
    }
    if (error) {
      console.log(error);
      return;
    }
    if (mloHeadshotActiveUrl) {
      // trim off the last 3 characters and replace with jpg
      mloHeadshotActiveUrl = mloHeadshotActiveUrl.slice(
        0,
        mloHeadshotActiveUrl.length - 3
      );
      mloHeadshotActiveUrl += "png";

      currentUser.userData.mloHeadshotFinal = mloHeadshotActiveUrl;
      setHasHeadshot(true);
    }
    console.log(currentUser.userData.mloHeadshotFinal);
  }, [data]);

  // console.log(currentUser);
  useEffect(() => {
    if (
      currentUser.brand?.headerColor == null ||
      currentUser.brand?.headerColor == "" ||
      currentUser.brand?.headerColor == undefined
    ) {
      history("/");
    }

    if (
      currentUser.brand?.ctaColor == null ||
      currentUser.brand?.ctaColor == "" ||
      currentUser.brand?.ctaColor == undefined
    ) {
      history("/");
    }
  }, [currentUser.brand?.headerColor, currentUser.brand?.ctaColor]);

  if (currentUser.brand?.headerColor) {
    currentUser.brand.rgbHeader = divideRgbBy255(currentUser.brand.headerColor);
  }

  if (currentUser.brand?.ctaColor) {
    currentUser.brand.rgbCta = divideRgbBy255(currentUser.brand.ctaColor);
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="border w-4/5 mx-auto bg-gray-100 rounded-md m-10 min-h-[740px]">
        <FlyerOptionsCustomizations hasHeadshot={hasHeadshot} />
      </div>
    </div>
  );
}
